import { AppIcon } from '../../app-icon-list/app-icon-list.model';
import { Provider } from '../../../../model/login.interface';
import { getIconForProvider } from '../../../../model/domain/cidaas.model';


export const mapProviderToAppIcon = (provider: Provider): AppIcon => ({
  label: provider.displayName,
  iconUrl: provider.logoUrl,
  ...( !provider.logoUrl  && { iconClass: getIconForProvider(provider.displayName) } || {} ),
  redirectUri: provider.redirectUri
});
